<div class="tooltip-background">
  <urm-property-info [externalPropertyReference]="externalPropertyReference" />
</div>
